import { type PaymentHistory, type CardList, CardEditUrl, PaymentMethodKind } from '~/lib/types/AdvAccount'
import { BackendApiRequest } from '../client'

export const createCard = async (token: string) => {
  await BackendApiRequest<void>({
    method: 'POST',
    url: '/v1/creditcard',
    data: {
      token: token,
    },
  })
}

export const addCard = async (token: string) => {
  await BackendApiRequest<void>({
    method: 'POST',
    url: '/v1/creditcard/add',
    data: {
      token: token,
    },
  })
}

export const setDefaultCard = async (cardId: string) => {
  await BackendApiRequest<void>({
    method: 'PATCH',
    url: '/v1/creditcard',
    data: {
      card_id: cardId,
    },
  })
}

export const deleteCard = async (cardId: string) => {
  await BackendApiRequest<void>({
    method: 'DELETE',
    url: '/v1/creditcard',
    data: {
      card_id: cardId,
    },
  })
}

export const getCardList = async () => {
  return await BackendApiRequest<CardList>({
    url: '/v1/creditcard',
  })
}

export const getCharges = async (offset = 0) => {
  return await BackendApiRequest<PaymentHistory>({
    url: '/v1/creditcard/payment_histories',
    params: { offset },
  })
}

export const getCardEditUrl = async () => {
  return await BackendApiRequest<CardEditUrl>({
    method: 'POST',
    url: '/v1/creditcard/get_card_edit_url',
  })
}

export const updatePaymentType = async () => {
  return await BackendApiRequest<{ paymentType: PaymentMethodKind }>({
    method: 'POST',
    url: '/v1/creditcard/payment_type',
  })
}
